import { Market, SelectionType, Selection } from "../../../data";
export class MarketGetter {
    constructor() {
        this.footballId = "1";
        this.marketTypeOrderBySport = {
            football: [SelectionType.ML, SelectionType.OU, SelectionType.HC, SelectionType.MLET, SelectionType.TGET, SelectionType.PW, SelectionType.TQ],
            other: [SelectionType.ML, SelectionType.HC, SelectionType.OU]
        };
        this.dummyMarkets = {
            ML: new Market({
                id: "1",
                name: "",
                type: SelectionType.ML,
                typeId: "",
                selections: [this.getDisabledDummySelection("1"),
                    this.getDisabledDummySelection("2"),
                    this.getDisabledDummySelection("3")],
                tags: []
            }),
            HC: new Market({
                id: "1",
                name: "",
                type: SelectionType.HC,
                typeId: "",
                selections: [this.getDisabledDummySelection("1"),
                    this.getDisabledDummySelection("2")],
                tags: []
            }),
            OU: new Market({
                id: "1",
                name: "",
                type: SelectionType.OU,
                typeId: "",
                selections: [this.getDisabledDummySelection("1"),
                    this.getDisabledDummySelection("2")],
                tags: []
            }),
            QA: new Market({
                id: "1",
                name: "",
                type: SelectionType.QA,
                typeId: "",
                selections: [this.getDisabledDummySelection("1"),
                    this.getDisabledDummySelection("2")],
                tags: []
            })
        };
    }
    /* Logic for market priorities */
    getCurrentMarket(pickedEvent) {
        if (pickedEvent.event) {
            let marketByPriority = this.getMarketByPriorities(pickedEvent.event, this.getMarket(pickedEvent), this.getMarketsPriorityBySport(pickedEvent.event.sportID));
            return marketByPriority
                ? marketByPriority
                : this.getFailoverMarket(pickedEvent);
        }
        return undefined;
    }
    getEmptyMarket(marketType) {
        return this.dummyMarkets[marketType];
    }
    getFailoverMarket(pickedEvent) {
        var failoverMarketType = pickedEvent.market ? pickedEvent.market.type : this.getMarket(pickedEvent);
        return this.dummyMarkets[failoverMarketType];
    }
    getMarketByPriorities(event, marketType, priorities) {
        for (let index = 0; index < event.markets.length; index++) {
            const market = event.markets[index];
            if (market.type === marketType) {
                return market;
            }
        }
        if (event.markets.length === 0) {
            return this.getEmptyMarket(marketType);
        }
        return this.getMarketByPriority(event.markets, priorities);
    }
    getMarketByPriority(markets, priorities) {
        for (let i = 0; i < priorities.length; i++) {
            const currentMarketType = priorities[i];
            for (let j = 0; j < markets.length; j++) {
                const market = markets[j];
                if (market.type === currentMarketType) {
                    return market;
                }
            }
        }
        return undefined;
    }
    getMarketsPriorityBySport(sportId) {
        if (sportId === this.footballId) {
            return this.marketTypeOrderBySport.football;
        }
        return this.marketTypeOrderBySport.other;
    }
    getMarket(event) {
        if (event.IsQA || event.IsOutright) {
            return SelectionType.QA;
        }
        switch (event.LineTypeID) {
            case 1:
                return SelectionType.ML;
            case 2:
                return SelectionType.HC;
            case 3:
                return SelectionType.OU;
            default:
                throw new Error("missing id for selection type");
        }
    }
    getDisabledDummySelection(_id) {
        return new Selection({
            id: _id,
            title: "",
            points: 0,
            odds: "",
            trueOdds: 0,
            lineGroupId: "",
            displayOdds: { decimal: "0" },
            isDisabled: true,
            isSelected: false,
            isSwapped: false,
            sbtechId: "",
            outcomeType: ""
        });
    }
}
//# sourceMappingURL=MarketGetter.js.map